import PropTypes from 'prop-types';
import OldMarkdownParser from './OldMarkdownParser/OldMarkdownParser';
import NewMarkdownParser from './MarkdownParser';
// import ModernMarkdownParser from './ModernMarkdownParser';

const checkMarkdownOldVersion = (content) => {
  return (
    content.includes('*{spacing}*') ||
    content.includes('|++|{') ||
    content.includes('%%%')
  );
};

const MarkdownParser = ({ content, useModernStyles = true }) => {
  const isMarkdownOldVersion = checkMarkdownOldVersion(content);

  if (isMarkdownOldVersion) {
    return <OldMarkdownParser text={content} />;
  }

  return useModernStyles ? (
      <NewMarkdownParser content={content} />
    // <ModernMarkdownParser content={content} />
  ) : (
    <NewMarkdownParser content={content} />
  );
};

MarkdownParser.propTypes = {
  content: PropTypes.string.isRequired,
  useModernStyles: PropTypes.bool,
};

export default MarkdownParser;
